import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios'
import { Url } from '../Url'


const ListadoRepartos = () => {
    const [repartos, setRepartos] = useState([])
    const [usuarios, setUsuarios] = useState([])
    const [usuario, setUsuario] = useState(0)
    const [total, setTotal] = useState(0)
    const [fechaInicio, setFechaInicio] = useState('')
    const [fechaFin, setFechaFin] = useState('')
    const { setVentaSelected, setFormView, setViewOpen, modify, idUsuario } = useContext(ContextStates)

    useEffect(() => {
        const calcTotal = () => {
            let t = 0;
            if (typeof repartos !== 'undefined') {
                repartos.forEach(element => {
                    t = t + parseInt(element.total)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [repartos])

    useEffect(() => {
        const getUsuarios = async () => {
            const formData = new FormData()
            formData.append('usuariocero', 1);
            formData.append('local', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listUsrs.php',
                    method: 'POST',
                    data: formData,
                })
                console.log("usuarios ", results)
                setUsuarios(results.data.results);
                setUsuario(results.data.results[0].id)
            } catch (e) {
                console.log(e)
            }
        }
        getUsuarios()
    }, [])

    useEffect(() => {
        const consultaRepartos = async () => {
            const formData = new FormData()
            formData.append('fechainicio', fechaInicio)
            formData.append('fechafin', fechaFin)
            formData.append('usuario', usuario)
            formData.append("idusuario", idUsuario)
            try {
                const response = await axios({
                    url: Url + 'api/listadoRepartos.php',
                    method: 'POST',
                    data: formData,
                })
                console.log(response)
                setRepartos(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaRepartos()
    }, [fechaInicio, fechaFin, modify, usuario])

    const handleView = (item) => {
        setVentaSelected(item)
        setFormView(0)
        setViewOpen(true)
    }

    const handleEdit = (item) => {
        setVentaSelected(item)
        setFormView(0)
        setViewOpen(true)
    }


    return (
        <div className="w-full py-5 px-2">
            <h2 className='mt-10 mb-5 text-gray-600 text-3xl text-center'>Repartos</h2>
            <div className="w-full md:w-11/12 mx-auto bg-slate-200 mt-5 mb-5 rounded-xl">
                <div className='w-full flex'>
                    <div className='w-1/2 p-3'>
                        <label htmlFor='fechainicio'>Fecha de Inicio</label>
                        <input type='date' className='w-full p-3 rounded-lg' id='fechainicio' placeholder='Fecha de Inicio' value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
                    </div>
                    <div className='w-1/2 p-3 ml-5 rounded-xl'>
                        <label htmlFor='fechafin'>Fecha de Fin</label>
                        <input type='date' className='w-full p-3 rounded-lg' id='fechafin' placeholder='Fecha de Fin' value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                    </div>
                </div>
                {usuarios && (
                    <div className='w-full p-5'>
                        <select
                            className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                            id='sUsuario'
                            value={usuario}
                            onChange={(e) => setUsuario(e.target.value)}
                        >
                            {usuarios.map((item, index) => (
                                <option key={index} value={item.id}>{item.nombre}</option>))
                            }
                        </select>
                    </div>
                )}
            </div>
            {typeof repartos !== 'undefined' && (
                <table className='w-full mx-auto'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white text-center'>
                            <th>Fecha</th>
                            <th>Hora</th>
                            <th>Total</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            repartos.map((item, index) => (
                                <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                    <td>{item.fecha}</td>
                                    <td>{item.hora}</td>
                                    <td>$ {item.total && parseFloat(item.total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    <td className='text-center'>
                                        <button className='bg-blue-600 hover:bg-blue-400 rounded-lg py-1 px-3 text-white' onClick={() => handleView(item)}>Ver</button>
                                        <button className='bg-red-600 hover:bg-red-400 rounded-lg py-1 px-3 ml-3 text-white' onClick={() => handleEdit(item)}>Editar</button>
                                    </td>
                                </tr>
                            ))
                        }
                        <tr className='border border-gray-300 p-2 text-center font-bold bg-slate-50'>
                            <td>Total</td>
                            <td>${total.toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            )}

        </div>
    )
}

export default ListadoRepartos